<template>
<div class="absolute" ref="divSize">
	<custom-popover ref="popover" @close="$emit('close')" :backdrop="true">
		<div class="create-method-popover" :class="{ 'has-changes': hasChanges , 'move-left' : moveLeft}">   
            <div class="reference-vars-title">{{templateMethod.name}}</div>

            <div v-for="(reference, index) in referencedVariablesArray" :key="index" >
                    <div class="reference">
                        <div class="info">
                            <div class="ref-title config ellipsis" @click="selectedReference = reference, showFormatting = false, handleConfigure(reference, index)">
                                <!-- <span style="margin-right:4px;">{{reference.name}}{{reference.name == 'format' ? '' : ': '}}</span> -->
                                <span style="margin-right:4px;">{{reference.name}}: </span>
                                <span v-if="reference.name !== 'format'">{{reference.constant ? 'Constant' : reference.variable ? reference.variable.displayName || reference.variable.name : 'Choose value'}}</span>
                                <span v-else>{{reference.displayResult ? reference.displayResult : 'Choose format'}}</span>
                            </div>
                            <div class="result">
                                <span  v-if="reference.name !== 'format'">{{reference.displayResult}}</span>
                                <button class="btn btn-xs" :class="selectedReference == reference && showFormatting && isOpen ? 'btn-primary' : 'btn-secondary' " v-if="reference.variable" @click="selectedReference = reference, showFormatting = true, handleFormatting(reference, index)">{{selectedReference == reference && showFormatting && isOpen ? 'Done' : 'Format' }}</button>
                            </div>
                        </div>
                    </div>

                    <div v-if=" isOpen == reference.name" class="config-area">       
                        <div v-if="reference.name == 'format'">
                            <!-- Formatting component here -->
							<variable-format-selector
                                class="variable-format"
                                :format="templateMethod.formatting"
                                :variable="templateMethod"
								:formatsForMethods="true"
                                @format-changed="format => onFormatChanged(format, index, true)"				
                            />
                        </div>
                        <div  v-else> 
                            <variable-selector
								v-if="!showFormatting " 
                                style="height: auto !important;"
                                :show-constant-input="true"
                                :variable-groups="$store.getters.variableGroups"
                                :selected-variable-name="reference.name ? reference.name : null"
                                :show-values=true
                                @constant-changed="constantValue => handleConstantInput(constantValue, reference, index)"
                                @variable-name-changed="variableName => onVariableNameChanged(variableName, reference, index)"
                            />
                            <variable-format-selector
                                v-if="showFormatting"
                                class="variable-format"
                                :variable="reference.variable || variable"
                                :format="reference.formatting"
                                @format-changed="format => onFormatChanged(format, index)"	
								@example-result="example => handleFormatExample(example, reference, index)"			
                            />
                        </div>
                    </div>
            </div>
			<div style="display: flex; flex-direction: column">
				<div class="save-footer" :class="{ 'can-save': hasChanges }">
					<div class="cancel" @click="onClose">
                        {{$t('editor-expression.cancel')}} 
                        <i class="fa-light fa-times"></i>
					</div>
					<div class="save" @click="createMethodFormat">
                        {{$t('editor-expression.save')}} 
						<i class="fa-light fa-check"></i>
					</div>
				</div>
			</div>
		</div>
	</custom-popover>
</div>
</template>

<script>
import VariableSelector from "@/components/VariableSelector";
import VariableFormatSelector from "@/components/VariableFormatSelector";
import CustomPopover from "@/components/CustomPopover";
import VariableHelpers from '@/assets/js/variableHelpers.js'
export default {
  name: "CreateTemplateMethodPopover",
  props: {
		templateMethod: { type: Object },
		methodInstance: {type: Object},
		top: Number,
		left: Number,
		moveLeft: Boolean,
		selectedText: String
  },
  data() {
    return {
		hasChanges: false,
		selectedReference: null,
		referenceArray: {},
		selectedVariable: null,
		referencedVariablesArray:[],
		// variableConstant: null,
		showFormatting: null,
		isOpen: null
		}
	},
	methods: {
		handleFormatExample(example, reference, index){

             this.$set(this.referencedVariablesArray[index], 'displayResult', example)
        
		},
        onVariableNameChanged (variableName, reference, index) {
            this.selectedVariable = { name: variableName, format: '' }
          
            let updatedReference = { 
                name: reference.name,
                variable: this.variable,
                displayResult: this.variable.value ? this.variable.value : this.variable.name,
                constant: null,
                format: reference.format,
            }
            if(this.variable.custom){
                this.$store.dispatch('getFormatExamples' ,{ 
                    variable: this.variable, 
                    formats: ['']
                    }).then((examples) => {
                        updatedReference.displayResult = examples[0].result
                        this.variable.displayName = VariableHelpers.extractPrettyNameVariableOnly(this.variable)
                        this.$set(this.referencedVariablesArray, index, updatedReference)
                    })
            }
            else{
                this.$set(this.referencedVariablesArray, index, updatedReference)
            }
            this.hasChanges = true
            this.isOpen = null
        },
        handleConstantInput(constantValue, reference, index){
            this.selectedVariable = null

            const updatedReference = { 
                name: reference.name,
                variable: this.variable,
                displayResult: constantValue,
                constant: constantValue,
                format: null
            }
            this.$set(this.referencedVariablesArray, index, updatedReference)
            this.hasChanges = true
		},

        onFormatChanged (format, index, methodFormat) {
            if(methodFormat){
                const updatedReference = {
                    name: 'format',
                    format: format,
                    displayResult: format
                }
                this.$set(this.referencedVariablesArray, index, updatedReference)
                // this.selectedVariable.format = format
            } else{
                
                this.$set(this.referencedVariablesArray[index], 'format', format)
            }
            // this.referencedVariablesArray[index].format = format
			this.hasChanges = true
            
            // this.onVariableUpdated()
		},
        handleConfigure(reference, index){
			this.selectedReference = null 
			if(this.isOpen == reference.name){this.isOpen = null, this.selectedReference = null }
			else this.isOpen = reference.name
		},
		handleFormatting(reference, index){
			if(this.isOpen == reference.name){this.isOpen = null}
			else this.isOpen = reference.name
        },
        
        createMethodFormat(){
            let convertedReferenceArray = []
			let convertToVariant = this.referencedVariablesArray.forEach(e => {
				if(e.constant){
					convertedReferenceArray.push(e.name +':' + e.constant)
				}
				if(e.variable){
					if(e.format){
						convertedReferenceArray.push(e.name + ':' + VariableHelpers.insertFormatting(e.variable.name, e.format))
					}
					else{
						convertedReferenceArray.push(e.name + ':' + e.variable.name)
					}
				}
				if(e.name === 'format' && e.format){convertedReferenceArray.push(e.name + ':' + e.format)}
			})
			this.$emit('template-method-updated', ':'+ this.templateMethod.name + '('+ convertedReferenceArray.join('|')+ ')')
        },
		onClose () {
			this.$emit('close')
		},
	},
    computed: {
		variable () {
			// return the actual variable, not the instance
			if (this.selectedVariable) return this.$store.getters.combinedVariables[this.selectedVariable.name]
			else return null
		}
    },
	watch: {
		variableInstance: {
			immediate: true,
			handler (variable) {
				if (variable) this.selectedVariable = {...variable}
			}
        },
        templateMethod: {
			immediate: true,
			handler (templateMethod) {
                if (templateMethod.referencedVariables)                     
                    this.referencedVariablesArray = templateMethod.referencedVariables.map(reference =>{
                        return{ name: reference, displayResult: ''}
                    })
                
			}
		}, deep:true
	},
	created(){
		//If the user opens/edits an already created method.
		if(this.methodInstance){
			const cleanedMethodString = this.methodInstance.values.substring(this.methodInstance.values.indexOf('(') +1, this.methodInstance.values.lastIndexOf(')')).split('|')
			cleanedMethodString.forEach((ref, index) => {
                // const refArray = ref.split(':')
                const refArray = ref.split(/:(.*)/)
                let reference;
                if(refArray.length == 1){reference = ''}
                else{
                    if(refArray[0] == 'format') {
                        reference = {
                            name: refArray[0],  
                            format: refArray[1],
                            displayResult: refArray[1]
                        }
                    } else{
                            reference = {
                                name: refArray[0],
                                variable: this.$store.getters.combinedVariables[VariableHelpers.removeFormatting(refArray[1])] ? this.$store.getters.combinedVariables[VariableHelpers.removeFormatting(refArray[1])] : null ,
                                constant:this.$store.getters.combinedVariables[VariableHelpers.removeFormatting(refArray[1])] ? null : refArray[1],
                                displayResult: this.$store.getters.combinedVariables[VariableHelpers.removeFormatting(refArray[1])] ? this.$store.getters.combinedVariables[VariableHelpers.removeFormatting(refArray[1])].value : refArray[1],
                                format: VariableHelpers.getFormatting(refArray[1]) ? VariableHelpers.getFormatting(refArray[1]) : ''
                            }
                        
                        if(VariableHelpers.getFormatting(refArray[1]) || this.$store.getters.combinedVariables[VariableHelpers.removeFormatting(refArray[1])] && this.$store.getters.combinedVariables[VariableHelpers.removeFormatting(refArray[1])].custom == true){
                            this.$store.dispatch('getFormatExamples' ,{ 
                                variable: this.$store.getters.combinedVariables[VariableHelpers.removeFormatting(refArray[1])], 
                                formats:  [VariableHelpers.getFormatting(refArray[1])] || []
                                }).then((examples) => {
                                    reference.displayResult = examples[0].result
                                })
                        }
                        if(reference.variable && !reference.variable.displayName){reference.variable.displayName =  VariableHelpers.extractPrettyNameVariableOnly(reference.variable)}
                    }                
                    this.$set(this.referencedVariablesArray, index, reference )
                }
			})
		}
	},
	components: {
		CustomPopover,
        VariableSelector,
        VariableFormatSelector
	},

}
</script>

<style lang="less">
    .absolute{
            position: absolute;
            top: 10px;
    }
	.custom-popover {
		position: fixed;
		z-index: 102;
			.create-method-popover {
				position: fixed;
				width: 300px;
				top: 70px;		
				// left: calc(100% - 388px);
                left: calc(100% - 388px + 68px);
				color: #3d464a;
				background: #fff;
				min-width: 250px;
				max-height: calc(100% - 85px);
                border-radius: var(--standard-border-radius);
                
				#variableFormatSelector .format-content {
					// max-height: 230px;
					box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
				}

				&.has-changes {
					#variableFormatSelector {
						padding-bottom: 0px;
						.format-content {
							// max-height: 295px;
							max-height: 190px;
						}
					}
				}

			.reference{
                    padding: 12px ;
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
				.info{
                    cursor: default;
                    
                    .ref-title{
                        cursor: pointer;
                        color: #3d464a;
						letter-spacing: 0.6px;
						line-height: 25px;
                        display: flex;
                        align-items: center;
                        flex-direction: row;
                    }
                    .config{
                        &:hover{
                            background-color: rgba(188, 193, 195, 0.2);
                        }
                    }
                    .result{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 4px;
                       span{
                            font-size: 12px;
                            opacity: 0.7;
                              cursor: default;
                       }
                       button{
                        //    margin-bottom: 4px;
                       }
                    }
				}
			}
			.reference-vars-title {
				font-size: 14px;
				padding: 14px 20px ;
				font-weight: 400;
				color: #8F979C;
				letter-spacing: 0.6px;
				line-height: 25px;
				// text-transform: uppercase;
				box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
			}
			.config-area{
				width: 300px;
				position: fixed;
				z-index: 998;
                .variable-selector{
                    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
                }
            }
            .save-footer{
                border-radius: 0 0 10px 10px;
            }
		}
	}

.create-method-popover.move-left{
		left: calc(100% - 590px);
	}
	
</style>


